import request from '../untils/request';

export const brandListApi = params => {
  return request({
    url: '/goods/brand/index',
    authCode: 'BRAND_INDEX',
    params,
  });
};

export const brandDeleteApi = params => {
  return request({
    url: '/goods/brand/delete-many',
    params,
  });
};

export const brandUpdateApi = params => {
  return request({
    url: '/goods/brand/update',
    params,
  });
};

export const brandCreateApi = params => {
  return request({
    url: '/goods/brand/create',
    params,
  });
};

export const goodsBrandListApi = params => {
  return request({
    url: '/goods/brand/brand-list',
    params,
  });
};

export const goodsBrandVerifyApi = params => {
  return request({
    url: '/goods/brand/brand_verify',
    params,
  });
};
